/* ──────────────────────────────────────────────────────────────
   RUN24 — Quick-add con talla desde la tarjeta de producto
   (snippets/run24-product-card.liquid).

   El botón + abre la tira de tallas disponibles de la tarjeta;
   tocar una talla agrega esa variante vía /cart/add con las
   sections del drawer y lo abre — mismo patrón que el upsell de
   run24-cart.js, que a su vez replica product-form.js de Dawn.

   Delegado en document: sobrevive al Section Rendering del PLP
   (run24-plp.js reemplaza el grid) sin re-bindear nada. El guard
   evita doble ejecución si dos secciones cargan el script.
   ────────────────────────────────────────────────────────────── */

(() => {
  if (window.__r24QuickAdd) return;
  window.__r24QuickAdd = true;

  function closeAll(except) {
    document.querySelectorAll('[data-r24-qa].r24-qa--open').forEach((qa) => {
      if (qa === except) return;
      qa.classList.remove('r24-qa--open');
      const toggle = qa.querySelector('[data-r24-qa-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  /* Alta directa (patrón run24-cart.js: /cart/add con sections del
     drawer + renderContents + publish). */
  function addVariant(btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    const originalLabel = btn.textContent;
    btn.textContent = '…';

    const drawer = document.querySelector('cart-drawer');
    const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id) : [];

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
        sections,
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then((response) => {
        btn.disabled = false;
        if (response.status) {
          // Error del cart API (p.ej. sin stock): se restaura la pill.
          btn.textContent = originalLabel;
          return;
        }
        btn.textContent = '✓';
        btn.classList.add('r24-qa__size--added');
        setTimeout(() => {
          btn.textContent = originalLabel;
          btn.classList.remove('r24-qa__size--added');
        }, 1600);
        closeAll(null);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'r24-quickadd', cartData: response });
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
        }
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = originalLabel;
      });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-r24-qa-toggle]');
    if (toggle) {
      // La tarjeta entera es un <a>: sin esto el + navega a la PDP.
      event.preventDefault();
      event.stopPropagation();
      const qa = toggle.closest('[data-r24-qa]');
      closeAll(qa);
      const open = qa.classList.toggle('r24-qa--open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    const sizeBtn = event.target.closest('[data-r24-qa-size]');
    if (sizeBtn) {
      event.preventDefault();
      event.stopPropagation();
      addVariant(sizeBtn);
      return;
    }

    if (event.target.closest('[data-r24-qa-tray]')) {
      // Tap en la tira sin tocar talla: no navegar a la PDP.
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    closeAll(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll(null);
  });
})();
